import { useMemo } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/slices/auth.slice";
import { fetchGroupSummary } from "../../services/groupConsole.service";

/**
 * The group's branches of one type — Senior (`isMontessori: false`) or
 * Junior/Montessori (`isMontessori: true`) — for the Course Board branch
 * picker. A branch is exclusively one or the other.
 *
 * Reuses the same GET /group-console/:groupId/summary call
 * useGroupProgramTypes.js already makes — react-query dedupes by key, so
 * this doesn't add a second network request.
 */
export default function useGroupBranchesByType(isMontessori) {
  const user = useSelector(selectUser);
  const groupId = user?.group;

  const summary = useQuery(
    ["group-console-summary", groupId],
    () => fetchGroupSummary(groupId),
    { enabled: !!groupId },
  );

  const options = useMemo(
    () =>
      (summary.data?.branches || [])
        .filter((b) => !!b.is_montessori_enabled === isMontessori)
        .map((b) => ({ value: b.school, label: b.school_name })),
    [summary.data, isMontessori],
  );

  return { options, isLoading: summary.isLoading };
}
